import { UploadError } from '@webapp/types/assets/upload-error';
import { AssetsState } from './state';
import { AssetUpload } from '../../types/assets/asset-upload';

export const assetsList = (
  assets: AssetsState,
  trackingId?: string
): AssetUpload[] => {
  return Object.values(assets.assets).filter((a) =>
    trackingId ? a.trackingId === trackingId : true
  );
};

export const getAssetById = (
  assets: AssetsState,
  assetId: string
): AssetUpload | undefined => {
  const asset = Object.values(assets.assets).find((a) => a.id === assetId);
  return !!asset ? asset : undefined;
};

export const totalProgress = (
  assets: AssetsState,
  trackingId?: string
): number => {
  const values = assetsList(assets, trackingId)
    .filter((t) => !!t.status)
    .map((t) => t.progress || 0);

  const sum = values.reduce((memo, v) => memo + v, 0);

  return sum / values.length;
};

export const generalStatus = (
  assets: AssetsState,
  trackingId?: string
): AssetUpload['status'] => {
  const values = assetsList(assets, trackingId)
    .map((t) => t.status)
    .filter((s) => !!s);

  if (values.includes('uploading')) {
    return 'uploading';
  }

  if (values.length) {
    return 'done';
  }
};

export const uploadErrors = (
  assets: AssetsState,
  trackingId?: string
): UploadError[] => {
  return assetsList(assets, trackingId)
    .filter((t) => !!t.error)
    .map((t) => ({
      filename: t.filename,
      error: t.error as string,
    }));
};

export const getTotalUploads = (
  assets: AssetsState,
  trackingId?: string
): number => {
  return assetsList(assets, trackingId).filter((t) => !!t.status).length;
};

export const getUploaded = (
  assets: AssetsState,
  trackingId?: string
): number => {
  return assetsList(assets, trackingId).filter((t) => t.status === 'done')
    .length;
};

export const allValid = (assets: AssetsState, ids: string[]): boolean => {
  return Object.values(assets.statuses)
    .filter((a) => ids.includes(a.assetId))
    .every((a) => a.isValid);
};
